// LivestreamWatermark.js
import { connect } from 'react-redux';

import LivestreamWatermark from '../component/LivestreamWatermark.jsx';

import getLiveStreamData from '../selector/getLiveStreamData.js';

const mapStateToProps = (state, { streamId }) => {
  const videoWidth = getLiveStreamData(state, [streamId], 'videoWidth');
  const videoHeight = getLiveStreamData(state, [streamId], 'videoHeight');

  return {
    videoWidth,
    videoHeight,
  };
};

export default connect(mapStateToProps)(LivestreamWatermark);
